import { differenceInYears, parse } from 'date-fns'
import { PatientDto } from '../Type/PatientDto'

export class Patient {
    public constructor(
        public id: number,
        public name: string,
        public maidenName: string,
        public firstName: string,
        public firstNameSecond: string,
        public firstNameThird: string,
        public firstNameFourth: string,
        public birthDate: string,
        public sex: string,
        public civility: string,
    ) {}

    public getCivilityKey(): string {
        return 'dPpatients:CPatient.civilite.' + this.civility
    }

    public getPatientFullName(): string {
        return `${this.name} ${this.firstName}`
    }

    public get age(): number {
        return differenceInYears(new Date(), parse(`${this.birthDate}`, 'yyyy-MM-dd', new Date()))
    }

    public toDto(): PatientDto {
        return {
            id: this.id,
            nom: this.name,
            nom_jeune_fille: this.maidenName,
            prenom: this.firstName,
            prenom_2: this.firstNameSecond,
            prenom_3: this.firstNameThird,
            prenom_4: this.firstNameFourth,
            naissance: this.birthDate,
            sexe: this.sex,
            civilite: this.civility,
        }
    }
}
